import React from "react";
import { motion } from "framer-motion";

import { AppWrap } from "../../wrapper";
import { images } from "../../constants";
import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => (
  <div className="app__header app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <div className="badge-cmp app__flex">
          <span>👋</span>
          <div style={{ marginLeft: 20 }}>
            <p className="p-text">Hello, I am</p>
            <h1 className="head-text">Burhan</h1>
          </div>
        </div>

        <div className="tag-cmp app__flex1">
          <p className="p-text">
          Hi, I'm Burhan, a passionate Web and Cloud Developer dedicated to building high-performance applications and optimizing platforms for businesses of all sizes. With expertise in web development, cloud solutions, and security consulting, I help businesses enhance their digital presence, streamline operations, and secure their platforms.
          With a strong focus on scalability, performance, and security, I ensure that businesses not only go online but thrive in the digital space. 
          </p>
        </div>

        <div className="tag-cmp app__flex1">
          <p className="p-text">
            <div> <p> Services I Provide:</p> 
            Website Development for Businesses 
          <p> SEO Analysis & Optimization </p>  
          <p> Application Development </p> 
          <p> Cloud Services & Hosting Solutions </p>    
          <p> File Management & Data Security </p>   
          <p>  AI Integration </p>  
          <p> Platform Security Consulting </p> </div>
          
          </p>
        </div>
      </div>
    </motion.div>

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__header-img"
    >
      <img src={images.profile} alt="profile_bg" />
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: "easeInOut" }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles"
    >
      {[images.aws1, images.aws2, images.kube].map((circle, index) => (
        <div className="circle-cmp app__flex" key={`circle-${index}`}>
          <img src={circle} alt="profile_bg" className="myImages" />
        </div>
      ))}
    </motion.div>
  </div>
);

export default AppWrap(Header, "home");
